module.exports = __webpack_public_path__ + "static/media/renew-poll.92d9f4a6.svg";